import { useEffect, useRef } from 'react';
import { useSession } from '../contexts/SessionContext';
import { useWebContainer } from '../contexts/WebContainerContext';

interface PreviewProps {
  router?: string;
  style?: React.CSSProperties;
  className?: string;
  width?: number | string;
  height?: number | string;
}

const Preview: React.FC<PreviewProps> = ({ router = '', style, className, width = '100%', height = '100%' }) => {
  const { loading, onError } = useSession();
  const { iframeSrc } = useWebContainer();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (!iframeRef.current) return;

    // 消息监听器
    const handleMessage = ({ data: { type }, data }: MessageEvent) => {
      // 处理来自iframe的错误消息
      if (type === 'webcontainer-error') {
        console.error('WebContainer error:', data);

        const {
          error: { message, filename, lineno, colno },
        } = data;
        // 调用传入的错误处理回调
        if (onError && message) {
          const from = filename
            ? `${
                filename.indexOf('webcontainer-api.io/') > -1
                  ? filename.substring(filename.indexOf('webcontainer-api.io/') + 20)
                  : filename
              }:${lineno}:${colno}`
            : '';
          onError({
            type: 'browser',
            message,
            from,
          });
        }
      }
    };

    // 添加消息监听器
    window.addEventListener('message', handleMessage);

    // 清理函数
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [iframeSrc, onError, loading]);

  if( loading || !iframeSrc ) return null;

  return (<iframe
    ref={iframeRef}
    src={router ? `${iframeSrc}/${router}` : iframeSrc}
    className={className}
    style={{ border: 'none', width, height, ...style }}
  />);
};

export default Preview;
